import React from 'react'
import {message, notification} from 'antd'
import {syncFulfillmentDesign} from "../../../../../services/api/3dApi"

const errorTemplate = (template, err) => {
    return (
        <div>
            <div>Template: {template}</div>
            <div>{err}</div>
        </div>
    )
}

export default async function (orderId, orderTemplate, onSuccess) {
    try {
        const hide = message.loading(`Đang đồng bộ designs #${orderTemplate}`, 0)

        const {data: response} = await syncFulfillmentDesign(orderId)

        hide()

        const {success, error} = response

        if (!success) {
            throw new Error(error)
        }

        message.success(`Đồng bộ thành công #${orderTemplate}`)

        onSuccess()
    } catch (e) {
        notification.error({
            message: 'Đồng bộ thất bại',
            description: errorTemplate(orderTemplate, e.message),
            duration: 0,
        })
    }
}
